// Run `fn` once the DOM has been parsed.
//
// Our bundles are loaded as <script type="module">, which the browser defers
// until parsing is complete — so by the time a module evaluates, the DOM is
// normally already available and `fn` runs immediately. The DOMContentLoaded
// fallback covers anything that evaluates earlier (e.g. the Vite dev server).
export function onReady(fn) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
        fn();
    }
}
